import type { FC } from "react";
import { cn } from "../../utils";

const CDN_CURRENCY_BASE =
  "https://cashier-module.imgix.net/images/icons/currencies";

// Currency code → icon filename on the CDN (without extension). Most codes map
// to their lowercased form; a few use a different asset name (BTC denominations
// share the bitcoin icon, Polygon's icon is still served as "matic").
const ICON_FILENAMES: Record<string, string> = {
  BTC: "btc",
  mBTC: "btc",
  uBTC: "btc",
  BRL: "brl",
  INR: "inr",
  TRY: "try",
  EUR: "eur",
  JPY: "jpy",
  SOC: "soc",
  ETH: "eth",
  LTC: "ltc",
  TRX: "trx",
  XRP: "xrp",
  USDT: "usdt",
  ADA: "ada",
  DOGE: "doge",
  POL: "matic",
  MATIC: "matic",
  SOL: "sol",
  BNB: "bnb",
  TON: "ton",
  DAI: "dai",
  USDC: "usdc",
  SHIB: "shib",
  BUSD: "busd",
  CAD: "cad",
  CNY: "cny",
  MXN: "mxn",
  USD: "usd",
  KRW: "krw",
};

type Props = {
  currency: string;
  className?: string;
};

const CurrencyIcon: FC<Props> = ({ currency, className }) => {
  const filename = ICON_FILENAMES[currency];

  if (!filename) {
    return <div className={cn("w-6 h-6", className)} />;
  }

  return (
    <img
      src={`${CDN_CURRENCY_BASE}/${filename}.svg`}
      width={24}
      height={24}
      alt={currency}
      className={cn("-m-0.5", className)}
    />
  );
};

export default CurrencyIcon;
